export default __webpack_public_path__ + "static/ensino-bilingue-f495fecb0742eb6623b06acc17b9c742.png";